import { EducationTooltip } from '@driftt/tide-tooltips-legacy'
import GoogleOAuthConnect from '../GoogleOAuthConnect'
import MicrosoftOAuthConnect from '../MicrosoftOAuthConnect'
import AvailabilitySettings from '../AvailabilitySettings'
import MeetingEmailSettings from '../MeetingEmailSettings'

import CalendarTabHeader from 'components/settings/meetings/CalendarTabHeader'
import { SectionItem } from 'components/shared/Section'
import { Link } from 'react-router'
import CalendarSettingsPage from '../page'

const CalendarAdvanced = ({
  googleAuthed,
  router,
  isGoogleOrMicrosoftConnected,
  isGloballyManagedAndInBeta,
  calendar
}) => {
  const CalendarConnector = googleAuthed ? GoogleOAuthConnect : MicrosoftOAuthConnect
  const connected = (isGoogleOrMicrosoftConnected || isGloballyManagedAndInBeta) && !!calendar.id
  return (
    <CalendarSettingsPage showHeaderBorder={false}>
      <CalendarTabHeader router={router} view="CALENDARS" />
      <div className="subsection top">
        <div className="settings-section-header">Your Availability</div>
      </div>
      <p className="settings-body-copy">
        Decide when and how people can book time for you. Your Drift Assistant will automatically check your calendar for existing events so you don’t get double booked.
      </p>
      <AvailabilitySettings />
      <div className="subsection">
        <MeetingEmailSettings /> 
      </div>

      <div className="subsection connected-calendar">
        <div className="settings-section-header">Your Connected Calendar</div>
        <p className="settings-body-copy">
          We’ll check this calendar for any conflicts when new meetings are being scheduled, and add new calendar events to it.
        </p>
        <CalendarConnector
          title="Your Connected Calendar"
          withDisconnect={true}
          autoSaveSelect={true}
          minimalUI={true}
          disconnectCallback={() => {
            setTimeout(() => {
              router.replace('/settings/calendar')
            }, 300)
          }}
        />
      </div>
      <hr className="advanced-calendar-hr"/>
      {connected && (
        <SectionItem
          title="Your Drift Assistant is connected to your calendar"
          description="The Drift Assistant helps you close more deals by preparing you for your meetings and sending you reminders for important deals so you never accidentally lose an opportunity again."
          className="assistant-config-footer-section"
        >
          <Link to="/settings2/assistant">Manage your Drift Assistant</Link>
        </SectionItem>
      )}
    </CalendarSettingsPage>
  )
}

export default CalendarAdvanced



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/CalendarAdvanced/component.js